export const ActivityColors = ({ activityData }) => {
  const { colours } = activityData;

  if (colours?.length > 1) {
    return (
      <div className="activity-feed-group-item__colours">
        {colours.slice(0, 3).map((colour, index) => {
          return (
            <div
              className="activity-feed-group-item__colours-item"
              style={{ background: `rgb(${colour.rgb})` }}
              key={index}
            ></div>
          );
        })}
      </div>
    );
  }

  return (
    <div
      className="activity-feed-group-item__colour"
      style={{ background: `rgb(${colours?.[0]?.rgb})` }}
    ></div>
  );
};
